import {Presenter} from '../../../Support/with_presenter';
import {CrewsService} from '../../../Network/CrewsService';
import {loadingResponse, NetworkResult} from '../../../Network/NetworkResult';
import {FullCrew} from '../../../Models/Crew';

export class CrewShowPresenter implements Presenter {
    public get name(): string | null {
        if (this.crew.status === 'success') {
            return this.crew.data.name;
        }
        if (this.previewName) {
            return this.previewName;
        }

        return null;
    }

    public crew: NetworkResult<FullCrew> = loadingResponse();

    constructor(private crewId: number, private previewName: string | null, private crewsService: CrewsService) {}

    public async mount(): Promise<void> {
        this.crew = await this.crewsService.get(this.crewId);
    }

    public unmount(): void {
        /* Noop */
    }
}
